import { Fragment, h } from "preact";
import { route, RouterProps } from "preact-router";
import { useBodyStyle } from "../hooks";
import { Container } from "../material";
import { useEditor } from "../hooks/useEditor";
import { useCallback, useEffect, useMemo, useState } from "preact/hooks";
import { Button } from "../material/button";
import { clearBasket, useShoppingBasket } from "../services/shoppingbasket";
import { CheckoutDetails, intitialCheckoutDetails } from "../services/data";
import { createOrder } from "../services/backend";
import type { FulfillmentMethod } from "../graphql/types";
import { getTodayString, jsonDateTimeWithoutTimezone, jsonDateWithoutTimezone } from "../services/utils";
import "./checkoutpage.scss";

export function CheckoutPage(props: RouterProps) {
    useBodyStyle("material");

    const { basket, setFromDate, setToDate } = useShoppingBasket();

    const initialData = useMemo(() => {
        return {
            ...intitialCheckoutDetails,
            startdate: intitialCheckoutDetails.startdate ?? basket?.fromDate,
            enddate: intitialCheckoutDetails.enddate ?? basket?.toDate,
        };
    }, [intitialCheckoutDetails]);

    const { data, setData, handleInputChange } = useEditor<CheckoutDetails>(initialData);
    const [showValidation, setShowValidation] = useState(false);
    const [isWaiting, setIsWaiting] = useState(false);
    const getClass = useCallback((name: keyof CheckoutDetails) => {
        return (!showValidation || !!data[name]) ? "" : "invalid";
    }, [showValidation, data])

    useEffect(() => {
        if (basket.entries.length == 0) {
            route("/")
        }
    });

    const onChangeFromDate = useCallback((e: h.JSX.TargetedEvent<HTMLInputElement, Event>) => {

        //handleInputChange(e);
        const val = (e.target! as any).value;
        const date = !!val ? new Date(val) : undefined;
        console.log("val: ", val, " - date: ", date);
        setFromDate(date);

        setData({
            ...data,
            startdate: date ?? null
        });
    }, [data]);

    const onChangeToDate = useCallback((e: h.JSX.TargetedEvent<HTMLInputElement, Event>) => {
        //handleInputChange(e);
        const val = (e.target! as any).value;
        const date = !!val ? new Date(val) : undefined;
        console.log("val: ", val, " - date: ", date);
        setToDate(date);
        setData({
            ...data,
            enddate: date ?? null
        });
    }, [data]);

    const submit = useCallback(async () => {
        setShowValidation(true);

        let isValid = !!data.fullname && !!data.phone && !!data.email && !!data.address && !!data.startdate && !!data.enddate && !!data.startuse && (data.fulfillmentmethod == "pickup" || (data.fulfillmentmethod == "delivery" && !!data.deliveryaddress && !!data.contactname && !!data.contactphone));
        if (!isValid) {
            console.log("invalid", data);
            return;
        }

        const payload = {
            items: basket.entries.map(entry => ({ id: entry.product.id, count: entry.count })),
            name: data.fullname,
            address: data.address,
            email: data.email,
            phone: data.phone,
            fromDate: jsonDateWithoutTimezone(data.startdate!),
            toDate: jsonDateWithoutTimezone(data.enddate!),
            useTime: jsonDateTimeWithoutTimezone(data.startuse!),
            fulfillmentMethod: (data.fulfillmentmethod == "pickup" ? "PICKUP" : "DELIVERY") as FulfillmentMethod,
            comments: data.comment,
        };
        console.log("PAYLOAD", payload);

        setIsWaiting(true);
        let ok: boolean | null = null;
        let errors = "";
        try {
            const result = await createOrder(payload);
            ok = result.data?.createOrder?.ok ?? false;
            if (!ok && result.errors) {
                errors = "\n\n" + result.errors.map(n => n.message).join("\n");
            }
        }
        catch (e) {
            console.log(e);
        }

        setIsWaiting(false);
        if (ok) {
            clearBasket();
            sessionStorage.setItem("sent", "yes");
            route("/confirmation");
            return null;
        } else {
            alert("Der var et problem med at sende din forespørgsel." + errors);
        }

    }, [data])

    //console.log(data);
    return (
        <Container class="grow column checkoutpage">
            <h1>Flexudlejning checkout</h1>
            <a href="/">&lt;&lt; Tilbage til forsiden</a>

            <div class="checkoutform">
                <h2>Kontaktoplysninger</h2>
                <div>
                    <label for="fullname" class={getClass("fullname")}>Fuldt navn</label>
                    <input id="fullname" name="fullname" type="text" value={data.fullname} onChange={handleInputChange} />
                </div>

                <div>
                    <label for="phone" class={getClass("phone")}>Telefonnummer</label>
                    <input id="phone" name="phone" type="text" value={data.phone} onChange={handleInputChange} />
                </div>

                <div>
                    <label for="email" class={getClass("email")}>Email</label>
                    <input id="email" name="email" type="text" value={data.email} onChange={handleInputChange} />
                </div>

                <div>
                    <label for="address" class={getClass("address")}>Adresse</label>
                    <input id="address" name="address" type="text" value={data.address} onChange={handleInputChange} />
                </div>
            </div>

            <div class="checkoutform">
                <h2>Lejeoplysninger</h2>

                <div>
                    <label for="startdate" class={getClass("startdate")}>Leje start</label>
                    <input id="startdate" name="startdate" type="date" min={getTodayString()} value={basket.fromDate?.toISOString().split('T')[0]} onChange={onChangeFromDate} />
                </div>

                <div>
                    <label for="enddate" class={getClass("enddate")}>Leje slut</label>
                    <input id="enddate" name="enddate" type="date" min={getTodayString()} value={basket.toDate?.toISOString().split('T')[0]} onChange={onChangeToDate} />
                </div>

                <div>
                    <label for="startuse" class={getClass("startuse")}>Brugstidspunkt</label>
                    <input id="startuse" name="startuse" type="datetime-local" min={getTodayString() + " 00:00:00"} step={60} value={formatDateForInput(data.startuse)} onChange={handleInputChange} />
                </div>

                <div>
                    <label class={!showValidation || !!data.fulfillmentmethod ? "" : "invalid"}>Leveringsmetode</label>
                    <div>
                        <input type="radio" id="deliverypickup" name="fulfillmentmethod" value="pickup" checked={data.fulfillmentmethod == "pickup"} onChange={handleInputChange}></input>
                        <label for="deliverypickup">Opsamling</label>
                        <br />
                        <input type="radio" id="deliveryshipping" name="fulfillmentmethod" value="delivery" checked={data.fulfillmentmethod == "delivery"} onChange={handleInputChange}></input>
                        <label for="deliveryshipping">Levering</label>
                    </div>
                </div>

                {
                    data.fulfillmentmethod == "delivery" && <Fragment>
                        <div>
                            <label for="deliveryaddress" class={getClass("deliveryaddress")}>Leveringsadresse</label>
                            <input id="deliveryaddress" name="deliveryaddress" type="text" value={data.deliveryaddress} onChange={handleInputChange} />
                        </div>

                        <div>
                            <label for="contactname" class={getClass("contactname")}>Kontaktperson navn</label>
                            <input id="contactname" name="contactname" type="text" value={data.contactname} onChange={handleInputChange} />
                        </div>

                        <div>
                            <label for="contactphone" class={getClass("contactphone")}>Kontaktperson telefon</label>
                            <input id="contactphone" name="contactphone" type="text" value={data.contactphone} onChange={handleInputChange} />
                        </div>
                    </Fragment>
                }
            </div>

            <div class="checkoutform">
                <div>
                    <label for="comments">Kommentarer</label>
                    <textarea id="comments" name="comments" onChange={handleInputChange} maxLength={8192}>{data.comment}</textarea>
                </div>
            </div>

            <div>
                <br />
                <Button onClick={submit} disabled={isWaiting}>Send</Button>
            </div>

        </Container>
    );
}

function formatDateForInput(date: Date | undefined | null) {
    if (!date) return undefined;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
}
